import { Component } from '@angular/core';
import { FinanceiroService } from './financeiro.service';
import { NotificationService } from '../../core/notification.service';

@Component({
  standalone: false,
  selector: 'app-registrar-pagamento',
  templateUrl: './registrar-pagamento.component.html',
  styleUrls: ['./registrar-pagamento.component.css']
})
export class RegistrarPagamentoComponent {
  fornecedorId = '';
  valor: number | null = null;
  metodoPagamento = 'PIX';
  dataRecebimento = '';
  comprovante = '';
  observacoes = '';

  loading = false;

  constructor(private svc: FinanceiroService, private notify: NotificationService) {}

  submit(): void {
    if (!this.fornecedorId || !this.valor || !this.metodoPagamento || !this.dataRecebimento) {
      this.notify.showInfo('Preencha os campos obrigatórios');
      return;
    }
    this.loading = true;
    this.svc.registrarPagamento({
      fornecedorId: this.fornecedorId,
      valor: this.valor!,
      metodoPagamento: this.metodoPagamento,
      dataRecebimento: this.dataRecebimento,
      comprovante: this.comprovante || undefined,
      observacoes: this.observacoes || undefined,
    }).subscribe({
      next: () => {
        this.loading = false;
        this.notify.showSuccess('Pagamento registrado e plano atualizado');
        this.fornecedorId = '';
        this.valor = null;
        this.metodoPagamento = 'PIX';
        this.dataRecebimento = '';
        this.comprovante = '';
        this.observacoes = '';
      },
      error: (err) => {
        this.loading = false;
        console.error('[Financeiro] erro ao registrar pagamento', err);
        this.notify.showError('Erro ao registrar pagamento');
      }
    });
  }
}
